import { useEffect, useState } from "react";
import { supabase } from "../../lib/supabase";

export default function SuspendedPage() {

  const [device, setDevice] = useState<string | null>(null);

  useEffect(() => {
    loadDevice();
  }, []);

  async function loadDevice() {

    const { data: userData } = await supabase.auth.getUser();
    const user = userData.user;

    if (!user) return;

    const { data } = await supabase
      .from("devices")
      .select("device_name")
      .eq("user_id", user.id)
      .order("created_at", { ascending: false })
      .limit(1)
      .single();

    if (data) {
      setDevice(data.device_name);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">

      <div className="max-w-xl w-full bg-white shadow-lg rounded-xl p-8 text-center space-y-6">

        <h1 className="text-2xl font-bold text-red-600">
          Account Access Restricted
        </h1>

        <p className="text-gray-700">
          Your account access has been restricted due to a violation of our
          device access policy.
        </p>

        <p className="text-gray-700">
          Our system detected a login attempt from an unapproved device. For
          security and compliance reasons, accounts attempting to access the
          platform from unauthorized devices are automatically restricted.
        </p>

        {device && (
          <div className="bg-gray-100 p-4 rounded-lg">
            <p className="text-sm text-gray-600">
              Detected Device
            </p>
            <p className="font-semibold text-gray-800">
              {device}
            </p>
          </div>
        )}

        <p className="text-gray-700">
          To restore access, you must contact our support team for verification.
        </p>

        <p className="text-sm text-gray-500">
          Please avoid attempting to log in from additional devices while your
          account is restricted, as this may delay the review process.
        </p>

        <div className="flex justify-center gap-4 pt-4">

          <a
            href="mailto:support@talisonservices.co.uk"
            className="bg-nhs-blue text-white px-5 py-2 rounded-lg hover:bg-nhs-dark transition"
          >
            Contact Support
          </a>

          <a
            href="/"
            className="border border-gray-300 px-5 py-2 rounded-lg hover:bg-gray-100 transition"
          >
            Return Home
          </a>

        </div>

      </div>

    </div>
  );
}